<template>
  <a-row class="content-fix">
    <a-page-header
      :ghost="false"
      :title="`Найдено ${items_count} новостей`"
      @back="() => $router.go(-1)"
    >
      <div slot="extra">
        <a-button
          style="margin-left: auto"
          type="primary"
          @click="
            $router.push({
              name: 'news-create',
              params: {
                category: $route.params.category
              }
            })
          "
        >
          <a-icon type="plus" />Добавить
        </a-button>
      </div>
      <div>
        <!-- <div class="content"> -->
        <a-form-model layout="inline" :model="queryParams">
          <a-form-model-item label="Поиск">
            <a-input v-model="queryParams.search" placeholder="Поиск" />
          </a-form-model-item>

          <a-form-model-item label="Категории">
            <a-select
              v-model="queryParams.category"
              :filter-option="filterOption"
              option-filter-prop="children"
              placeholder="Выберите категорию"
              show-search
              style="width: 200px"
            >
              <a-select-option
                v-for="category in $store.getters['category/list']"
                :key="category.slug"
                :value="category.slug"
              >
                {{ JSON.parse(category.title)[$i18n.locale] }}
              </a-select-option>
            </a-select>
          </a-form-model-item>

          <a-form-model-item label="Тип новости">
            <a-select
              v-model="queryParams.state"
              :default-value="queryParams.state"
              option-filter-prop="children"
              placeholder="Выберите тип"
              show-search
              style="width: 200px"
            >
              <a-select-option
                v-for="item in newsStates"
                :key="item.value"
                :value="item.value"
              >
                {{ item.text }}
              </a-select-option>
            </a-select>
          </a-form-model-item>

          <a-form-model-item>
            <a-button @click="clearQueryParams"> Очистить форму </a-button>
            <a-button type="primary" @click="setRoute"> Поиск </a-button>
          </a-form-model-item>
        </a-form-model>
        <!-- </div> -->
      </div>
    </a-page-header>

    <a-table
      :columns="columns"
      :data-source="news || []"
      :loading="loading"
      :pagination="false"
      :row-key="(rec) => rec.id"
    >
      <template
        v-for="(column, cindex) in columns"
        :slot="column.key"
        slot-scope="item, index"
      >
        <TableCells
          :key="index + cindex"
          :slot-key="column.key"
          :item="item"
          @removeItem="removeItem"
        />
        <template />
      </template>
    </a-table>
    <a-row class="mt-1">
      <!-- v-model="queryParams.page" -->
      <a-pagination
        :current="+$route.query.page || 1"
        show-size-changer
        :page-size="+queryParams.limit"
        :total="+items_count"
        @showSizeChange="onShowSizeChange"
        @change="onChange"
      />
    </a-row>
  </a-row>
</template>

<script>
// import osgImage from "@/components/image/osgImage/osgImage";
// import tags from "@/components/tableComponents/tags";
import TableCells from "@/components/tableComponents/TableCells"
import { CONTENT_LANGUAGES } from "@/constants"
import { mapState } from "vuex"

const columns = [
  {
    title: "Заголовок",
    key: "news_title",
    scopedSlots: { customRender: "news_title" }
  },

  {
    title: "Языки",
    key: "language_support_with_flag",
    width: 260,
    scopedSlots: { customRender: "language_support_with_flag" }
  },

  {
    title: "Категория",
    key: "category",
    width: "15%",
    scopedSlots: { customRender: "category" }
  },

  {
    title: "Действие",
    key: "operation",
    fixed: "right",
    scopedSlots: { customRender: "operation" }
  }
]

export default {
  components: {
    TableCells
  },
  data: () => ({
    loading: false,
    columns,
    categoryProps: {},
    autocompleteItems: [],
    tag: null,
    optionTags: null,
    selectedTags: [],
    query: "",
    news: [],
    items_count: 1,
    page: 1,
    defaultRange: null,
    queryParams: {
      category: null,
      till: null,
      from: null,
      tag: [],
      page: 1,
      limit: 10,
      state: 0
    },
    formItemLayout: {},

    newsStates: [
      {
        value: 0,
        text: "Опубликованные"
      },
      {
        value: 1,
        text: "В ожидании"
      },
      {
        value: 2,
        text: "Отклоненные"
      }
    ]
  }),
  computed: {
    contentLanguages: () => CONTENT_LANGUAGES,
    filteredItems() {
      return this.autocompleteItems.filter(
        (i) =>
          (i.text || "")
            .toLowerCase()
            .indexOf((this.tag || "").toLowerCase()) !== -1
      )
    },
    ...mapState({
      profile: (state) => state.user.profile || {}
    })
  },
  watch: {
    $route: {
      handler: "fetchData",
      immediate: true
    },

    "queryParams.state": {
      handler: "setRoute"
    }
  },
  created() {
    this.fillOptions()

    this.setQueryParamsFromRoute()
    this.setdefaultDate()
  },
  mounted() {
    this.$on("update:slug", this.onSlugChange)
  },
  methods: {
    setdefaultDate() {
      const range = []
      if (this.moment(this.queryParams.from, "DD-MM-YYYY", true).isValid()) {
        range.push(this.moment(this.queryParams.from, "DD-MM-YYYY"))
      }
      if (this.moment(this.queryParams.till, "DD-MM-YYYY", true).isValid()) {
        range.push(this.moment(this.queryParams.till, "DD-MM-YYYY"))
      }

      this.defaultRange = range[0] && range[1] ? range : null
    },
    clearQueryParams() {
      this.queryParams = {
        category: null,
        till: null,
        from: null,
        tag: [],
        type: 0,
        page: 1,
        limit: 10,
        state: 0
      }
    },
    onShowSizeChange(current, pageSize) {
      this.queryParams.limit = +pageSize
      this.queryParams.page = +current
      this.setRoute()
    },
    onChange(pageNumber) {
      this.queryParams.page = +pageNumber
      this.setRoute()
    },
    handleChangeTag(tag, checked) {
      if (!checked && this.queryParams.tag) {
        const index = this.queryParams.tag.findIndex((el) => el === tag.id)
        if (index >= 0) {
          this.queryParams.tag.splice(index, 1)
        }
      } else {
        if (this.queryParams.tag) {
          this.queryParams.tag.push(tag.id)
        } else {
          this.queryParams.tag = [tag.id]
        }
      }
      this.queryParams.page = 1
      this.queryParams.limit = 10
    },
    setRoute() {
      let newParams = {}
      Object.keys(this.queryParams).forEach((key) => {
        if (this.queryParams[key]) {
          newParams[key] = this.stringifyOrNumb(this.queryParams[key])
        }
      })

      newParams = {
        ...newParams,
        state: this.queryParams.state
      }

      // if(this.profile && this.profile.id +this.profile.access_level != 1) {
      //   newParams = {
      //     ...newParams,
      //     author_id: this.profile.id
      //   }
      // }

      this.$router.push({ query: newParams }, () => {})
    },
    onChangeDate(date, dateString) {
      this.queryParams.till = dateString[1]
      this.queryParams.from = dateString[0]
    },
    isNumber(n) {
      return !isNaN(parseFloat(n)) && !isNaN(n - 0)
    },
    stringifyOrNumb(val) {
      return this.isNumber(val) ? +val : val
    },
    setQueryParamsFromRoute() {
      Object.keys(this.$route.query).forEach((key) => {
        if (this.$route.query[key]) {
          if (
            this.moment(this.queryParams[key], "DD-MM-YYYY", true).isValid()
          ) {
            this.queryParams[key] = this.moment(this.$route.query[key]).format(
              "DD-MM-YYYY"
            )
          } else {
            this.queryParams[key] = this.stringifyOrNumb(this.$route.query[key])
          }
        }
      })
    },
    async fillOptions() {
      this.optionTags = await this.$store.dispatch("tags/fetch")
      this.$store.dispatch("category/fetch")
      this.queryParams.category_id = +this.$route.params.category || null
    },
    bytesToSize(bytes) {
      const sizes = ["Bytes", "KB", "MB", "GB", "TB"]
      if (bytes === 0) return "n/a"
      const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)), 10)
      if (i === 0) return `${bytes} ${sizes[i]})`
      return `${(bytes / 1024 ** i).toFixed(1)} ${sizes[i]}`
    },
    getFirstFulfilled(fields) {
      let lang = this.$i18n.locale
      if (!fields) return {}
      if (fields[lang]) {
        return {
          text: fields[lang],
          lang: lang
        }
      } else {
        const lang = Object.keys(fields).find((l) => fields[l])
        if (!lang) {
          return {}
        }
        return {
          text: fields[lang],
          lang: lang
        }
      }
    },
    async fetchData() {
      this.loading = true
      const params = {
        page: 1,
        limit: 10
      }

      Object.keys(this.$route.query).forEach((key) => {
        if (this.$route.query[key]) {
          params[key] = this.stringifyOrNumb(this.$route.query[key])
        }
      })

      if (params.state && +this.profile.access_level != 1) {
        params.author_id = this.profile.id
      }

      try {
        const r = await this.$store.dispatch("news/fetch", params)

        if (r) {
          this.items_count = r.items_count || 0
          this.news = r.results || []
        }
        this.loading = false
      } catch (e) {
        console.error(e)
        this.loading = false
      }
    },
    async removeItem(item) {
      try {
        const res = await this.$store.dispatch("news/deleteItemAction", item.id)

        if (this.resOK(res)) {
          const f = this.categoryProps.news.findIndex(
            (elem) => elem.id === item.id
          )

          if (f !== -1) {
            this.categoryProps.news.splice(f, 1)
          }
        }
      } catch (e) {
        console.error(e)
      }
    }
  }
}
</script>
